import CheckIcon from "@material-ui/icons/Check";
/* eslint-disable react/display-name */
import React, { FC } from "react";
import { GridColDef } from "@material-ui/data-grid";

import BaseDataGrid from "../../../../../components/modules/BaseDataGrid";
import Button from "../../../../../components/elements/Button";
import classes from "./HubspotPagesDashboard.module.scss";

type HubspotPage = {
  id: number;
  name: string;
  url: string;
  pageType: "BLOG" | "LANDING" | "WEB";
  state: string;
};

type HubspotPagesDashboardProps = {
  hubspotPages: HubspotPage[];
  selectedLandingPage: string;
  handleSelectLandingPage: (selectedLandingPage: string) => void;
};

const HubspotPagesDashboard: FC<HubspotPagesDashboardProps> = ({
  hubspotPages,
  selectedLandingPage,
  handleSelectLandingPage,
}) => {
  const columns: GridColDef[] = [
    { field: "name", headerName: "Name", width: 250 },
    {
      field: "url",
      headerName: "URL",
      width: 600,
      renderCell: ({ value }) => (
        <a href={value as string} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      ),
    },
    { field: "pageType", headerName: "Page Type", width: 120 },
    { field: "state", headerName: "State", width: 250 },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: ({ value }) => {
        return (
          <Button
            className={classes.selectButton}
            variant={selectedLandingPage === value ? "contained" : "outlined"}
            onClick={() => handleSelectLandingPage(value as string)}
          >
            {selectedLandingPage === value ? "Selected" : "Select"} <CheckIcon />
          </Button>
        );
      },
    },
  ];

  const rows = hubspotPages.map(({ id, name, url, pageType, state }) => ({
    id: id.toString(),
    name,
    url,
    pageType,
    state,
    action: url,
  }));

  return (
    <div className={classes.container}>
      <BaseDataGrid columns={columns} rows={rows} />
    </div>
  );
};

export default HubspotPagesDashboard;
